import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import jsPDF from 'jspdf';
import { Unsubscriber } from 'src/shared/components/unsubscriber/unsubscriber.component';
import { CircuitBoxService } from 'src/shared/services/circuit-box.service';
import { ErrorLibService } from 'src/shared/services/error-lib.service';
import Swal from 'sweetalert2';
import { CircuitBox, EquipmentTypeCircuitBox, GatewayCircuitBox, PaginationInfo } from './assets/circuit-box-model';

// Imports Standalone
import { PageHeaderComponent } from 'src/shared/components/page-header/page-header.component';
import { TableHeaderComponent } from 'src/shared/helper-components/table-header/table-header.component';
import { RegisterFormComponent } from '../register-form/register-form.component';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { ButtonModule } from 'primeng/button';

import { FloatLabelModule } from "primeng/floatlabel";
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputTextModule } from 'primeng/inputtext';
@Component({
  selector: 'app-circuit-box',
  templateUrl: './circuit-box.component.html',
  styleUrls: ['./circuit-box.component.less'],
  imports: [
    CommonModule,
    PageHeaderComponent,
    TableHeaderComponent,
    RegisterFormComponent,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSelectModule,
    MatProgressBar,
    ButtonModule,
    TranslateModule,
    FloatLabelModule,
    KeyFilterModule,
    InputTextModule
  ]
})
export class CircuitBoxComponent extends Unsubscriber implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    public errorLibService: ErrorLibService,
    private circuitBoxService: CircuitBoxService
  ) {
    super();
  }

  ngOnInit(): void {
    this.filterGateway();
  }

  // Variaveis responáveis por abrir e fechar as boxes
  public register: boolean = false;
  public registerLoading: boolean = false;
  public filter: boolean = false;
  public filterLoading: boolean = false;
  public equipmentsTypesID: any = [];
  public equipmentTypeCorte: EquipmentTypeCircuitBox[] = [];
  public equipmentTypeIPC: EquipmentTypeCircuitBox[] = [];
  public equipmentTypeIPCUpdate: EquipmentTypeCircuitBox[] = [];
  public equipmentTypeCorteUpdate: EquipmentTypeCircuitBox[] = [];
  public typeFilter = "";
  public filteredReference: string;
  public loadingEquipmentsIPC = false;
  public loadingEquipmentsCORTE = false;
  public updateLoading: boolean = false;

  // Controlador para apresentação da label edição de caixas de circuito.
  public editorController: boolean = false;
  public gatewayInstallationList: GatewayCircuitBox[] = [];

  //Variavel responsável por armazenas os dados da tabela
  public ELEMENT_DATA: CircuitBox[] = [];

  public paginationProperties: PaginationInfo = new PaginationInfo(0, 0, false, false, null, null);

  /** Variáveis utilizadas para manipulação do Paginator **/
  public pageIndex: number = 0;
  public pageSize: number = 10;
  public length: number = 0;
  public previousPageIndex: number = 0;

  // Renderiza os comandos da lista ELEMENT_DATA para a tabela
  public dataSource = new MatTableDataSource<CircuitBox>(this.ELEMENT_DATA);

  /** Variáveis utilizadas para geração e manipulação dos arquivos PDF e CSV **/
  public FILE_DATA: CircuitBox[] = [];
  public fileLoading = false;
  public isReady = false;

  // Utilizado para bloquear caracteres especiais na referencia das caixas de circuito (criação e atualização)
  public blockSpecialCharacters: RegExp = /^(?!\s)[a-zA-Z0-9_ -]*$/;

  // Armazena os dados do formulário de filtro das circuitBox, o valor é setado automáticamente pelo HTML
  public filterCircuitBoxForm: FormGroup = this.formBuilder.group({
    reference: [null],
  });

  // Armazena os dados do formulário de registro das circuitBox, o valor é setado automáticamente pelo HTML
  public registerCircuitBoxForm: FormGroup = this.formBuilder.group({
    reference: [
      null,
      [
        Validators.required,
        Validators.pattern(/^(?!\s)[a-zA-Z0-9_ -]*$/)
      ]
    ],
    ipc: [null, Validators.required],
    searchIPC: [null, Validators.required],
    searchCorte: [null, Validators.required],
    gateway: [null, Validators.required],
    consumption: [null, Validators.required],
  });

  // Armazena os dados do formulário de registro das circuitBox, o valor é setado automáticamente pelo HTML
  public updateCircuitBoxForm: FormGroup = this.formBuilder.group({
    id: null,
    reference: [
      null,
      [
        Validators.required,
        Validators.pattern(/^(?!\s)[a-zA-Z0-9_ -]*$/)
      ]
    ],
    searchUpdateIPC: [null, Validators.required],
    searchUpdateCorte: [null, Validators.required],
    sgIpcSerialNumber: [null, Validators.required],
    sgIpcID: [null, Validators.required],
    sgGatewayReference: [null, Validators.required],
    sgGatewayID: [null, Validators.required],
    sgConsumptionSerialNumber: [null, Validators.required],
    sgConsumptionID: [null, Validators.required],
  });

  // Função responsável por mudar o estado da box de registro e fechar a de filtro
  public registerBox(): void {
    this.filter = false;
    this.register = !this.register;
  }

  public filterBox(): void {
    this.register = false;
    this.filter = !this.filter;
  }

  //Função que configura o paginatior
  public setDataSourceAttributes() {
    this.dataSource.data = this.ELEMENT_DATA;
  }

  //Variáveis usadas para o paginator e para o sort.
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /** Função chamada toda vez que ocorre um evento no paginator **/
  public pageChanged(event: any) {

    /** Armazena o indice da página atual **/
    const newPageIndex = event.first;

    /** Atualiza o valor da página anterior para a página atual **/

    this.previousPageIndex = this.pageIndex;

    /** Atualiza o índice da página atual **/
    this.pageIndex = newPageIndex;

    /**
     * Caso o botão pressionado seja o de página anterior utiliza o
     * startCursor como cursor para o novo filtro
     *
     * Caso o botão pressionado seja o de próxima página é utilizado
     * o endCursor como cursor
     **/
    if (this.previousPageIndex > newPageIndex) {
      this.filterCircuitBox(this.paginationProperties.startCursor)

    } else if (this.previousPageIndex < newPageIndex) {
      this.filterCircuitBox(this.paginationProperties.endCursor)
    }
  }

  /**
 * Função responsavel por criar as caixas de circuitos
 */

  public registerCircuitBox() {
    if (this.registerCircuitBoxForm.valid) {

      this.registerLoading = true;

      this.circuitBoxService.registerCircuitBox(
        this.registerCircuitBoxForm.get("reference")?.value,
        this.registerCircuitBoxForm.get("consumption")?.value,
        this.registerCircuitBoxForm.get("gateway")?.value,
        this.registerCircuitBoxForm.get("ipc")?.value
      ).subscribe({
        next: ((response: any) => {
          // Armazena os dados da caixa de circuito para cadastro do IPC posteriormente
          let reference = response?.data?.circuitBoxCreate.circuitBox?.reference
          let siteId = response?.data?.circuitBoxCreate.circuitBox?.sgGateway?.site?.id
          let circuitBoxId = response?.data?.circuitBoxCreate?.circuitBox?.id

          // Cria uma instalação com o IPC para comandos/relatórios/gráficos de consumo
          this.circuitBoxService.createIpcInstallation(
            reference + " - IPC",
            siteId,
            null,
            false,
            'PUBLIC_LIGHTING',
            null,
            circuitBoxId
          ).subscribe({

            next: ((response: any) => {
              // Desativa o loading
              this.registerLoading = false;

              // Alerta de sucesso
              Swal.fire({
                title: 'Caixa de circuito criada com sucesso',
                text: 'Caixa de circuito e instalação auxiliar cadastradas com sucesso',
                icon: 'success',
                confirmButtonText: 'Ok'
              });

              // Em caso de erro retornado pela API (InstlalationCreate)
            }), error: (error: any) => {
              this.errorLibService.errorAlert(error);
              this.registerLoading = false;
            }
          })


        }),
        // Em caso de erro retornado pela API (CircuitBoxCreate)
        error: (error: any) => {
          this.errorLibService.errorAlert(error);
          this.registerLoading = false;
        }
      })
    }
  }

  /**
* Função responsavel por filtrar as caixas de circuitos
*/
  public filterCircuitBox(cursor: string | null) {

    if (cursor === null) {
      this.pageIndex = 0;
      this.isReady = true;
    }

    this.filteredReference = this.filterCircuitBoxForm.get('reference')?.value;
    if (this.filterCircuitBoxForm.valid) {

      this.filterLoading = true;

      this.circuitBoxService.filterCircuitBox(
        this.filteredReference,
        cursor,
        this.pageSize
      ).valueChanges.subscribe({
        next: ((response: any) => {

          /** Valida se a resposta está carregando ou se não tem dados **/
          if (response.loading || !response.data) {
            return;
          }

          // Adiciona as informações de paginação da API na página.
          this.paginationProperties = new PaginationInfo(
            response.data?.circuitBox?.count,
            response.data?.circuitBox?.total,
            response.data?.circuitBox?.pageInfo?.hasNextPage,
            response.data?.circuitBox?.pageInfo?.hasPreviousPage,
            response.data?.circuitBox?.pageInfo?.startCursor,
            response.data?.circuitBox?.pageInfo?.endCursor
          )

          this.ELEMENT_DATA = [];
          this.length = this.paginationProperties.total;
          this.isReady = false;

          // Adiciona cada empresa retornada pela requisição na lista
          response?.data?.circuitBox?.edges.forEach((node: any) => {
            this.ELEMENT_DATA.push(
              new CircuitBox(
                node?.node?.id,
                node?.node?.reference,
                node?.node?.sgIpc?.serialNumber,
                node?.node?.sgIpc?.id,
                node?.node?.sgGateway?.reference,
                node?.node?.sgGateway?.id,
                node?.node?.sgConsumption?.serialNumber,
                node?.node?.sgConsumption?.id
              ));
          })

          /** Atualiza a tabela com os novos dados **/
          this.setDataSourceAttributes();

          if (this.ELEMENT_DATA.length === 0) {
            /** Retorna alerta ao usuário **/
            Swal.fire({
              title: 'Sua busca não retornou resultados',
              text: 'Nenhum resultado para este filtro',
              icon: 'warning',
              confirmButtonText: 'Ok'
            });
          }

          this.filterLoading = false;
        }),
        error: (error: any) => {
          this.filterLoading = false;
          this.errorLibService.errorAlert(error);
        }
      })
    }
  }

  public filterGateway() {
    this.circuitBoxService.filterGateway().subscribe({
      next: ((response: any) => {
        response?.data?.gatewayInstallation?.edges.forEach((node: any) => {
          this.gatewayInstallationList.push(
            new GatewayCircuitBox(node?.node?.id, node?.node?.reference));
        });
      }),
      error: (error: any) => {
        console.log("filterGateway", error)
        this.errorLibService.errorAlert(error);
      }
    })
  }

  public filterEquipmentBySerialNumber(searchField: string, type: string, typeFilter: string) {
    this.typeFilter = typeFilter

    const search = this.registerCircuitBoxForm.get(searchField)?.value || this.updateCircuitBoxForm.get(searchField)?.value

    if (!search) {
      return
    }

    this.loadingEquipmentsIPC = type == "ipc" ? true : false
    this.loadingEquipmentsCORTE = type == "corte" ? true : false

    this.circuitBoxService.filterEquipment(search).valueChanges.subscribe({
      next: ((response: any) => {
        if (type == "ipc") {

          this.equipmentTypeIPCUpdate = typeFilter == "update" ? [] : this.equipmentTypeIPCUpdate
          this.equipmentTypeIPC = typeFilter == "update" ? this.equipmentTypeIPC : []

          // Variável para exibição de alerta
          let foundEquipment: boolean = false;

          response?.data?.equipment?.edges.forEach((node: any) => {
            if (node?.node?.equipmentType?.reference?.toLowerCase() == "sgipc") {
              foundEquipment = true;

              if (typeFilter == "update") {
                this.equipmentTypeIPCUpdate.push(
                  new EquipmentTypeCircuitBox(
                    node?.node?.id,
                    node?.node?.equipmentType?.reference,
                    node?.node?.serialNumber,
                    node?.node?.equipmentType?.major,
                    node?.node?.equipmentType?.minor,
                    node?.node?.equipmentType?.revision
                  ));

              } else {
                this.equipmentTypeIPC.push(
                  new EquipmentTypeCircuitBox(
                    node?.node?.id,
                    node?.node?.equipmentType?.reference,
                    node?.node?.serialNumber,
                    node?.node?.equipmentType?.major,
                    node?.node?.equipmentType?.minor,
                    node?.node?.equipmentType?.revision
                  ));
              }
            }
          });

          // Esse alerta será exibido mesmo que sejam encontrados outros equipamentos que não sejam IPC
          if (!foundEquipment) {
            Swal.fire({
              title: 'Nenhum equipamento encontrado',
              text: 'Não foi encontrado nenhum equipamento do tipo IPC com o numero de série digitado.',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }

        } else if (type == "corte") {

          // Variável para exibição de alerta
          let foundEquipment: boolean = false;

          this.equipmentTypeCorteUpdate = typeFilter == "update" ? [] : this.equipmentTypeCorteUpdate
          this.equipmentTypeCorte = typeFilter == "update" ? this.equipmentTypeCorte : []

          response?.data?.equipment?.edges.forEach((node: any) => {
            if (node?.node?.equipmentType?.reference?.toLowerCase() == "sgcorte") {
              foundEquipment = true;
              if (typeFilter == "update") {
                this.equipmentTypeCorteUpdate.push(
                  new EquipmentTypeCircuitBox(
                    node?.node?.id,
                    node?.node?.equipmentType?.reference,
                    node?.node?.serialNumber,
                    node?.node?.equipmentType?.major,
                    node?.node?.equipmentType?.minor,
                    node?.node?.equipmentType?.revision
                  ));
              } else {
                this.equipmentTypeCorte.push(
                  new EquipmentTypeCircuitBox(node?.node?.id,
                    node?.node?.equipmentType?.reference,
                    node?.node?.serialNumber,
                    node?.node?.equipmentType?.major,
                    node?.node?.equipmentType?.minor,
                    node?.node?.equipmentType?.revision
                  ));
              }
            }
          });

          // Esse alerta será exibido mesmo que sejam encontrados outros equipamentos que não sejam Corte
          if (!foundEquipment) {
            Swal.fire({
              title: 'Nenhum equipamento encontrado',
              text: 'Não foi encontrado nenhum equipamento do tipo Corte com o numero de série digitado.',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        }

        this.loadingEquipmentsIPC = false
        this.loadingEquipmentsCORTE = false
      }),
      error: (error: any) => {
        console.log(error)
        this.errorLibService.errorAlert(error);
      }
    })
  }

  /**
* Função responsavel por criar as caixas de circuitos
*/

  public updateGetter(element: any) {
    delete element.view
    this.updateCircuitBoxForm.setValue({
      ...element,
      searchUpdateIPC: element?.sgIpcSerialNumber,
      searchUpdateCorte: element?.sgConsumptionSerialNumber
    });
    this.editorController = true;
  }

  // Fecha a barra lateral quando clicado no botão.
  public closeEditionSideBar() {
    // Fecha a tela lateral.
    this.editorController = false;
  }

  public updateCircuitBox() {
    if (this.updateCircuitBoxForm.valid) {

      this.updateLoading = true;

      this.subscriptions = this.circuitBoxService.updateCircuitBox(
        this.updateCircuitBoxForm.get("id")?.value,
        this.updateCircuitBoxForm.get("reference")?.value,
        this.updateCircuitBoxForm.get("sgConsumptionID")?.value,
        this.updateCircuitBoxForm.get("sgGatewayID")?.value,
        this.updateCircuitBoxForm.get("sgIpcID")?.value
      ).subscribe({
        next: ((response: any) => {
          console.log(response)
          this.ELEMENT_DATA = [
            new CircuitBox(
              response?.data?.circuitBoxUpdate?.circuitBox?.id,
              response?.data?.circuitBoxUpdate?.circuitBox?.reference,
              response?.data?.circuitBoxUpdate?.circuitBox?.sgIpc?.serialNumber,
              response?.data?.circuitBoxUpdate?.circuitBox?.sgIpc?.id,
              response?.data?.circuitBoxUpdate?.circuitBox?.sgGateway?.reference,
              response?.data?.circuitBoxUpdate?.circuitBox?.sgGateway?.device?.id,
              response?.data?.circuitBoxUpdate?.circuitBox?.sgConsumption?.serialNumber,
              response?.data?.circuitBoxUpdate?.circuitBox?.sgConsumption?.id
            )
          ];
          this.setDataSourceAttributes();
          this.editorController = false;
          this.updateLoading = false;
          Swal.fire({
            title: 'Caixa de circuito atualizada',
            text: 'Caixa de circuito atualizada com sucesso',
            icon: 'success',
            confirmButtonText: 'Ok'
          });
        }),
        error: (error: any) => {
          console.log("UpdateCircuitBox", error)
          this.errorLibService.errorAlert(error);
          this.updateLoading = false;
        }
      })
    } else {
      Swal.fire({
        text: 'Verifique os campos e tente novamente!',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    }
  }

  // ---------------------------------------------------------------------
  // Código destinado à funções de download de CSV e PDF da página.

  public generateFileData(cursor: string | null, fileType: string) {
    this.fileLoading = true;
    /** Verifica se a lista está pronta **/
    if (this.isReady == false) {
      this.subscriptions = this.circuitBoxService.filterCircuitBox(
        this.filteredReference,
        cursor,
        50
      ).valueChanges.subscribe({
        next: ((response: any) => {
          /** Valida se a resposta está carregando ou não possui dados **/
          if (response.loading || !response.data) {
            return;
          }

          // Adiciona as informações de paginação da API na página.
          this.paginationProperties = new PaginationInfo(
            response?.data?.circuitBox?.count,
            response?.data?.circuitBox?.total,
            response?.data?.circuitBox?.pageInfo?.hasNextPage,
            response?.data?.circuitBox?.pageInfo?.hasPreviousPage,
            response?.data?.circuitBox?.pageInfo?.startCursor,
            response?.data?.circuitBox?.pageInfo?.endCursor
          )

          this.ELEMENT_DATA = [];
          this.length = this.paginationProperties.total;

          // Adiciona cada empresa retornada pela requisição na lista
          response?.data?.circuitBox?.edges.forEach((node: any) => {
            this.FILE_DATA.push(
              new CircuitBox(
                node?.node?.id,
                node?.node?.reference,
                node?.node?.sgIpc?.serialNumber,
                node?.node?.sgIpc?.id,
                node?.node?.sgGateway?.reference,
                node?.node?.sgGateway?.id,
                node?.node?.sgConsumption?.serialNumber,
                node?.node?.sgConsumption?.id
              ));
          })

          /** Caso seja a última página a lista está completa **/
          if (!response?.data?.circuitBox?.pageInfo?.hasNextPage) {
            this.isReady = true;
          }

          this.generateFileData(response?.data?.circuitBox?.pageInfo?.endCursor, fileType);

          this.filterLoading = false;
        }),
        error: (error: any) => {
          console.log("referenceCircuitBox", error)
          this.errorLibService.errorAlert(error);
        }
      })
    } else {
      this.fileLoading = false;
      if (fileType === "PDF") {
        this.downloadPDF();
      } else {
        this.downloadCSV();
      }
    }
  }

  // Converte o conteúdo em CSV. Privado porque só usa aqui nessa classe.
  private convertToCSV(arr: any) {
    // Transforma o objeto numa lista onde o primeiro elemento é o cabeçalho com o nome das colunas.
    const content = [Object.keys(arr[0])].concat(arr);

    // Retorna o conteúdo mapeado como string linha a linha adicionando quebra de linha em cada um.
    return content
      .map((item) => {
        return Object.values(item).toString().replace(',', ';');
      })
      .join('\n');
  }

  /** Método que realiza o download do arquivo em CSV **/
  public downloadCSV() {

    let content: any = [];

    // Adicoina cada elemento como um objeto na lista de conteúdo.
    this.FILE_DATA.forEach((circuitBox) => {
      content.push({
        "Referência": circuitBox?.reference,
        "IPC(Serial Number)": circuitBox?.sgIpcSerialNumber,
        "Gateway": circuitBox?.sgGatewayReference,
        "Corte(Serial Number)": circuitBox?.sgConsumptionSerialNumber
      });
    });

    // Adiciona o conteúdo convertido dentro de uma nova variável.
    let data = this.convertToCSV(content);
    // Transforma o conteúdo para o formato blob para geração do arquivo.
    let file = new Blob([data], { type: 'text/csv' });
    // Cria um endereçamento para o arquivo.
    let url = window.URL.createObjectURL(file);
    // Cria um elemento para a linkagem do arquivo.
    let link = document.createElement('a');
    // Adiciona a url no elemento de linkagem.
    link.href = url;
    // Nomeia o arquivo que será feito o download.
    link.download = `${new Date().toLocaleDateString()}-${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}-circuit-box.csv`;
    // Adiciona o link no documento.
    document.body.appendChild(link);
    // Atica o evento de click para realizar o download.
    link.click();
    // Remove o link do documento.
    document.body.removeChild(link);
    // Remove o endereço do download.
    window.URL.revokeObjectURL(url);

    this.FILE_DATA = [];
    this.isReady = false;
    return

  }

  // Função que realiza o download do CSV.
  public downloadPDF() {
    // Define o cabeçalho do documento.
    const header = ['Referência', 'IPC(Serial Number)', "Gateway", "Corte(Serial Number)"];
    // Lista que irá conter o conteúdo retornado pela API.
    let content: any = [];
    // Inserção do conteúdo na lista.
    this.FILE_DATA.forEach((circuitBox) => {
      content.push([circuitBox?.reference, circuitBox?.sgIpcSerialNumber, circuitBox?.sgGatewayReference, circuitBox?.sgConsumptionSerialNumber]);
    });
    // Define o formato do documento.
    let file: any = new jsPDF('l', 'mm', 'a4');
    // Cria o PDF.
    file.autoTable({
      theme: 'grid',
      margin: { top: 20 },
      head: [header],
      body: content,
    });
    // Gera o download do documento.
    file.save(
      `${new Date().toLocaleDateString()}-${new Date().getHours()}:${new Date().getMinutes()}-circuit-box.pdf`
    );

    this.FILE_DATA = [];
    this.isReady = false;
  }
}
